module.exports = __webpack_public_path__ + "static/us-expertise.2a975ddd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/us-expertise.jpg
// module id = 517
// module chunks = 246449838016611